<template>
  <div class="contracts-container">
    <Header></Header>
    
    <!-- 切换标签 -->
    <div class="tab-container">
      <el-radio-group v-model="activeTab" size="large">
        <el-radio-button label="write">写合同</el-radio-button>
        <el-radio-button label="review">审合同</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 两栏布局内容区 -->
    <div class="content-container">
      <WriteContract v-if="activeTab === 'write'" />
      <ReviewContract v-if="activeTab === 'review'" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import WriteContract from './components/WriteContract.vue'
import ReviewContract from './components/ReviewContract.vue'

export default {
  name: 'Contracts',
  components: {
    Header,
    WriteContract,
    ReviewContract
  },
  data() {
    return {
      activeTab: 'write' // 默认显示写合同
    }
  }
}
</script>

<style lang="less" scoped>
.contracts-container {
  min-height: 100vh;
  background: #f0f2f5;

  .tab-container {
    padding: 20px 0;
    text-align: center;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  }

  .content-container {
    margin: 24px auto;
    width: 95%;
    min-height: calc(100vh - 180px);
  }
}
</style>
